import { Fragment } from 'react';
import PropTypes from 'prop-types';

import withTheme from 'core/hocs/withTheme';

import Checkable from '../Checkable';
import Icon from './Icon';

import { resolveScopedStyles } from 'core/utils/styled-jsx';

import themePropTypes from 'core/utils/prop-types/theme';

/**
 * @author Ivan Sakharov <i.sakharov@rambler-co.ru>
 */
function Checkbox(props) {
  const {
    theme,
    icon: CheckboxIcon,
    type,
    ...inputProps
  } = props;

  const scope = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .icon
          :global(.idle)
            fill ${theme.controls.checkbox[type].idle.fill}

          :global(.focus)
            fill ${theme.controls.checkbox[type].focus.fill}

          :global(.checked)
            fill ${theme.controls.checkbox[type].checked.fill}

          :global(.disabled)
            fill ${theme.controls.checkbox[type].disabled.fill}

          :global(.checked-disabled)
            fill ${theme.controls.checkbox[type].checkedDisabled.fill}

          :global(.focus)
          :global(.checked)
            transition \
              fill-opacity ${theme.animations.hover},
      `}</style>
    </scope>
  );

  return (
    <Fragment>
      <Checkable
        {...inputProps}
        type='checkbox'
        gap='10px'
        icon={iconProps => {
          const {
            className,
            ...otherProps
          } = iconProps;

          return (
            <CheckboxIcon
              {...otherProps}
              className={scope.wrapClassNames('icon', className)}
            />
          );
        }}
      />
      <scope.styles />
    </Fragment>
  );
}

Checkbox.defaultProps = {
  type: 'basic',
  icon: Icon,
};

Checkbox.propTypes = {
  /** @ignore */
  theme: themePropTypes(`
    {
      animations: {
        hover,
      },
      colors: {
        hint,
        active1
      },
    }
  `),
  /**
   * Элемент, используемый в качестве иконки
   */
  icon: PropTypes.func,
  /**
   * Тип чекбокса, определяемый темой
   */
  type: PropTypes.oneOf(['basic', 'secondary']),
};

const CheckboxWithHOCs = withTheme(Checkbox);
CheckboxWithHOCs.displayName = 'Checkbox';

export { Checkbox as StorybookComponent };
export default CheckboxWithHOCs;
